import { type RouteObject, RouterProvider, createBrowserRouter, useParams } from 'react-router-dom';
import { ErrorPage } from 'src/components/ErrorPage';
import { ElevationChartView } from 'src/views/ElevationChartView';

const elevationChartRoutes: Array<RouteObject> = [
  {
    path: '/elevation-chart/:eventSlug',
    element: <ElevationChartView />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/elevation-chart',
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
];

const router = createBrowserRouter(elevationChartRoutes);

export const ElevationChartRouter = () => {
  return <RouterProvider router={router} />;
};

export const useElevationChartParams = (): Readonly<Partial<{ eventSlug: string }>> => {
  return useParams<{ eventSlug: string }>();
};
